export default "__VITE_PUBLIC_ASSET__2944ee72__"